module.exports = __webpack_public_path__ + "kudos_8.svg?a47c619fecf107df0b37c47b728a0a54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_8.svg
// module id = 183
// module chunks = 0